<template>
  <div>
    <CRow>
      <CCol
        v-if="showMainTable"
        :md="tableColSize"
        :lg="tableColSize"
        :xl="tableColSize"
        :xxl="tableColSize"
        xs="12"
        sm="12"
      >
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Insumos"
          icon="fas fa-coins"
          btn_name="Insumo"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'10%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtd_table_price="mtd_table_price"
          @mtd_table_inputUnit="mtd_table_inputUnit"
          @mtd_get_campus="mtd_get_campus"
          :buttonBack="true"
        />
      </CCol>
      
      <CCol
        v-for="table in priceTables"
        :key="table.id"
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <button
          @click="removePriceTable(table.id)"
          class="btn btn-dark mb-1 d-flex"
        >
          <i class="fas fa-eye"></i>
          <div class="ml-2">Ocultar</div>
        </button>
        <CTableWrapper
          :items="table.data"
          :fields="table.fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`Lista de Precios - ${table.name_input}`"
          icon="fas fa-dollar-sign"
          btn_name="Precios"
          @mtdBack="mtdBack"
          @show_modal="mtd_price"
          @action_edit="mtd_show_price"
          :size="'md'"
          :button_new="table.data.length == 0 ? true : false"
          :actions="true"
          :withActions="'10%'"
          :buttonEdit="true"
          :buttonDelete="false"
          :myButtons="[]"
          :buttonBack="false"
        />
      </CCol>

      <CCol
        v-for="table in inputUnitTables"
        :key="table.id"
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <button
          @click="removeInputUnitTable(table.id)"
          class="btn btn-dark mb-1 d-flex"
        >
          <i class="fas fa-eye"></i>
          <div class="ml-2">Ocultar</div>
        </button>
        <CTableWrapper
          :items="table.data"
          :fields="table.fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`Lista de Insumo x Unidad - ${table.name_input}`"
          icon="fas fa-hockey-puck"
          btn_name="Insumo x Unidad"
          @mtdBack="mtdBack"
          @show_modal="mtd_inputUnit"
          @action_edit="mtd_show_inputUnit"
          :size="'md'"
          :button_new="true"
          :actions="false"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="false"
          :myButtons="[]"
          :buttonBack="false"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="input.name"
          />
        </CCol>
        <CCol
          v-if="modal.action == 'store'"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mb-2"
        >
          <label class="mb-2">Sedes donde registrar el insumo:</label>
          <div class="campus-table-container border p-3 rounded">
            <div v-if="data_campus.length === 0" class="text-muted">
              No hay sedes disponibles
            </div>
            <table v-else class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Sede</th>
                  <th>Precio venta</th>
                  <th>Stock Mínimo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campus in data_campus" :key="campus.id">
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'campus-' + campus.id"
                        :value="campus.id"
                        v-model="selectedCampuses"
                        @change="toggleCampusInputs(campus.id)"
                      />
                      <label
                        class="custom-control-label"
                        :for="'campus-' + campus.id"
                      >
                        {{ campus.name }}
                      </label>
                    </div>
                  </td>
                  <td>
                    <CInput
                      type="number"
                      placeholder="Precio"
                      v-model="campusPrices[campus.id]"
                      :disabled="!isCampusSelected(campus.id)"
                      @input="validatePositiveInput(campusPrices, campus.id)"
                    />
                  </td>
                  <td>
                    <CInput
                      type="number"
                      placeholder="Stock mínimo"
                      v-model="campusStockMin[campus.id]"
                      :disabled="!isCampusSelected(campus.id)"
                      @input="validatePositiveInput(campusStockMin, campus.id)"
                      @keydown="preventDecimal"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-2">
              <a href="#" @click.prevent="selectAllCampuses" class="mr-3"
                >Seleccionar todas</a
              >
              <a href="#" @click.prevent="deselectAllCampuses">Quitar todas</a>
            </div>
          </div>
        </CCol>
        <CCol
          v-if="modal.action != 'store'"
          xs="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
        >
          <CInput
            label="Stock Mínimo"
            type="number"
            :min="0"
            v-model="input.stock_min"
            @input="validationNumber()"
            @keydown="preventDecimal"
          />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="input.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal precios -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button_price"
      :show.sync="modal.modal_form_price"
      @mtd_action="mtd_action_price"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Precio de Venta"
            type="number"
            placeholder="Digete precio de venta"
            v-model="price.sale_price"
            @change="validatePositive('sale_price')"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Precio de Compra"
            type="number"
            placeholder="Digete precio de compra"
            v-model="price.purchase_price"
            @change="validatePositive('purchase_price')"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal Insumo x Unidad -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button_inputUnit"
      :show.sync="modal.modal_form_inputUnit"
      @mtd_action="mtd_action_inputUnit"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <cSelectForm
            label="Unidad"
            placeholder="Seleccione unidad"
            :options="data_units"
            :value.sync="inputUnit.unit_id"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Insumo'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />

    <!-- modal campus -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modalCampu.title"
      :button="false"
      :show.sync="modalCampu.modal_form"
      @mtd_action="mtd_action_campus"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            disabled
            v-model="modalCampu.name"
          />
        </CCol>
        <CCol xs="12" sm="12" md="12" lg="12" xl="12" class="mb-2">
          <label class="mb-2">Sedes donde registrar el insumo:</label>
          <div class="campus-table-container border p-3 rounded">
            <div v-if="data_campus.length === 0" class="text-muted">
              No hay sedes disponibles
            </div>
            <table v-else class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Sede</th>
                  <th>Precio venta</th>
                  <th>Stock Mínimo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campus in editCampu" :key="campus.id">
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'campus-' + campus.id"
                        v-model="campus.select"
                      />
                      <label
                        class="custom-control-label"
                        :for="'campus-' + campus.id"
                      >
                        {{ campus.name }}
                      </label>
                    </div>
                  </td>
                  <td>
                    <CInput
                      type="number"
                      placeholder="Precio"
                      v-model="campus.price"
                    />
                  </td>
                  <td>
                    <CInput
                      type="number"
                      placeholder="Stock mínimo"
                      v-model="campus.stock"
                      @keydown="preventDecimal"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </CModalForm>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "campu_name", label: "Sede", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
  },
  data() {
    return {
      prefix: "inputs",
      fields,
      data: [],
      data_units: [],
      data_campus: [],
      selectedCampuses: [],
      campusPrices: {},
      campusStockMin: {},
      tableColSize: 12, // Valor inicial de la tabla
      showMainTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Agregar Precio",
          action: "mtd_table_price",
          icon: "fas fa-dollar-sign",
        },
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Unidad de Insumo",
          action: "mtd_table_inputUnit",
          icon: "fas fa-hockey-puck",
        },

        {
          class: "btn-sm",
          color: "info",
          tooltip: "Sedes",
          action: "mtd_get_campus",
          icon: "fas fa-table",
        },
      ],
      modal: {
        action: "",
        title: "",
        modal_form: false,
        modal_form_price: false,
        modal_form_inputUnit: false,
      },
      input: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: "",
        name: "",
        stock_min: 0,
        state: 0,
        campus_ids: [],
        campus_data: [],
      },
      price: {
        input_id: "",
        sale_price: 0,
        purchase_price: 0,
        state: 0,
      },
      inputUnit: {
        input_id: "",
        unit_id: "",
        unit: {},
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      priceTables: [],
      inputUnitTables: [],
      nextPriceTableId: 1, // Counter for unique table ID
      nextInputUnitTableId: 1, // Counter for unique table ID
      /** modal campu */
      editCampu: [],
      modalCampu: {
        action: "",
        title: "",
        modal_form: false,
        name: "",
      },
    };
  },
  computed: {
    cpStatus: function () {
      if (this.input.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (
        this.input.name != "" &&
        (this.modal.action !== "store" || this.selectedCampuses.length > 0)
      )
        return false;
      return true;
    },
    
    cp_button_price: function () {
      if (this.price.sale_price != "") return false;
      return true;
    },
    cp_button_inputUnit: function () {
      if (this.inputUnit.unit_id != "") return false;
      return true;
    },
  },
  watch: {
    selectedCampuses: {
      handler(value) {
        this.input.campus_ids = [...value];
      },
      deep: true,
    },
  },
  created() {
    this.getCampus();
    this.mtd_getdata();
    this.show_Unit();
  },
  methods: {
    ...mapActions(["get", "post"]),
    isCampusSelected(campusId) {
      return this.selectedCampuses.includes(campusId);
    },
    // Método para activar/desactivar inputs al seleccionar/deseleccionar campus
    toggleCampusInputs(campusId) {
      if (!this.isCampusSelected(campusId)) {
        // Si se deselecciona, limpiar los valores
        this.campusPrices[campusId] = "";
        this.campusStockMin[campusId] = "";
      } else {
        // Si se selecciona, inicializar con valores por defecto
        this.campusPrices[campusId] = this.campusPrices[campusId] || 0;
        this.campusStockMin[campusId] = this.campusStockMin[campusId] || 0;
      }
    },
    // Validación para asegurar números positivos en los inputs
    validatePositiveInput(obj, key) {
      const value = parseInt(obj[key], 10);
      if (isNaN(value) || value < 0) {
        obj[key] = 0;
      }
    },
    selectAllCampuses() {
      // Verificar si todas las sedes ya están seleccionadas
      const allSelected =
        this.data_campus.length === this.selectedCampuses.length;

      if (allSelected) {
        return; // Ya están todas seleccionadas
      }

      // Seleccionar todas las sedes e inicializar sus valores
      this.selectedCampuses = this.data_campus.map((campus) => {
        // Inicializar precio y stock para cada campus seleccionado
        this.campusPrices[campus.id] = this.campusPrices[campus.id] || 0;
        this.campusStockMin[campus.id] = this.campusStockMin[campus.id] || 0;
        return campus.id;
      });
    },

    deselectAllCampuses() {
      // Limpiar todas las selecciones y valores
      this.selectedCampuses = [];
      this.campusPrices = {};
      this.campusStockMin = {};
    },

    // selectAllCampuses() {
    //   this.selectedCampuses = this.data_campus.map(campus => campus.id);
    // },
    // deselectAllCampuses() {
    //   this.selectedCampuses = [];
    // },
    validationNumber() {
      const quantity = parseInt(event.target.value, 10);
      if (quantity < 1) {
        this.input.stock_min = 0;
      }
    },
    preventDecimal(event) {
      // Prevenir que se ingresen puntos decimales o comas
      if (event.key === "." || event.key === ",") {
        event.preventDefault();
      }
    },
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          this.data.forEach((item) => {
            switch (item.state) {
              case "Activo":
                item.status = "Activo";
                break;
              case "Inactivo":
                item.status = "Inactivo";
                break;
              default:
                item.status = "Desconocido";
            }
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Insumo")
        : (this.modal.title = "Editar Insumo");
      action == "store"
        ? (this.input = {
            id: "",
            company_id: this.$store.getters.get_company.id,
            name: "",
            stock_min: 0,
            state: "",
            campus_ids: [],
          })
        : (this.input = { ...this.input });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.input.campus_data = this.selectedCampuses.map((campusId) => ({
        campus_id: campusId,
        price: parseFloat(this.campusPrices[campusId] || 0),
        stock_min: parseInt(this.campusStockMin[campusId] || 0, 10),
      }));
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.input,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Insumo ya resgistrado",
              icon: "warning",
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedInput = response.data.data;
              let index = this.data.findIndex(
                (input) => input.id === updatedInput.id
              );
              if (index !== -1) {
                this.$set(this.data, index, updatedInput);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            this.input = {
              id: "",
              company_id: this.$store.getters.get_company.id,
              name: "",
              stock_min: 0,
              state: 0,
              campus_ids: [],
              campus_data: [],
            };
            this.selectedCampuses = [];
            this.campusPrices = {};
            this.campusStockMin = {};
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.input = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      }).then((response) => {
        this.mtd_getdata();
        this.modal_delete = {
          boo: false,
          item: [],
        };

        Swal.fire({
          title: "ELIMINADO CORRECTAMENTE",
          icon: "success",
        });
      });
    },
    changeSwitch: function (payload) {
      this.input.state = payload == true ? 1 : 0;
    },
    removeBarcodeTable(tableId) {
      this.nextBarcodeTableId = 1;
      this.barcodeTables = this.barcodeTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.barcodeTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    mtd_table_price: function (id) {
      /* if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      } */
      if (this.inputUnitTables.length != 0) {
        this.removeInputUnitTable(this.inputUnitTables[0].id);
      }
      if (this.priceTables.length == 1) {
        this.removePriceTable(this.priceTables[0].id);
      }

      // this.tableColSize = 7;
      this.price.input_id = id.Id;
      this.price.purchase_price = 0;
      this.price.sale_price = 0;

      // Ocultar la tabla principal
      this.showMainTable = false;

      // Add a new barcode table
      if (this.nextPriceTableId == 1) {
        const newPriceTable = {
          id: this.nextPriceTableId,
          data: [], // You can fill this with actual barcode data as needed
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            {
              key: "sale_price",
              label: "Precio de venta",
              _style: "width:20%;",
            },
            {
              key: "purchase_price",
              label: "Precio de compra",
              _style: "width:20%;",
            },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_input: id.name,
        };
        this.priceTables.push(newPriceTable);
        this.mtd_getdata_price(newPriceTable.id, id.Id);
        this.nextPriceTableId += 1;
      }
    },
    removePriceTable(tableId) {
      this.nextPriceTableId = 1;
      this.priceTables = this.priceTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.priceTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/getCampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_campus = response.data;
      });
    },
    mtd_price: function (action) {
      // this.tableColSize = 7;
      this.modal.modal_form_price = true;
      if (action == "update") {
        this.modal.title = "Editar Precio";
        this.modal.action = action;
      } else {
        this.modal.title = "Agregar Precio";
        this.modal.action = "store";
        // this.price.input_id="";
        this.price.purchase_price = 0;
        this.price.sale_price = 0;
        this.price.state = 0;
      }
    },
    mtd_getdata_price: function (tableId, inputId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byPrice/" +
          this.$store.getters.get_company.id +
          "/" +
          inputId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // this.data = response.data.data;
          const tableIndex = this.priceTables.findIndex(
            (table) => table.id === tableId
          );
          if (tableIndex !== -1) {
            this.$set(this.priceTables[tableIndex], "data", response.data.data);
            // Agregar un índice a cada elemento en la data
            let index = 1;
            this.priceTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_show_price: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/inputprices/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.price = response;
          this.mtd_price("update");
          // this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_table_inputUnit: function (id) {
      if (this.priceTables.length != 0) {
        this.removePriceTable(this.priceTables[0].id);
      }
      /* if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      } */
      if (this.inputUnitTables.length == 1) {
        this.removeInputUnitTable(this.inputUnitTables[0].id);
      }

      // this.tableColSize = 7;
      this.inputUnit.input_id = id.Id;
      this.inputUnit.unit_id = "";

      // Ocultar la tabla principal
      this.showMainTable = false;

      // Add a new barcode table
      if (this.nextInputUnitTableId == 1) {
        const newInputUnitTable = {
          id: this.nextInputUnitTableId,
          data: [],
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "unit_name", label: "Unidad", _style: "width:20%;" },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_input: id.name,
        };
        this.inputUnitTables.push(newInputUnitTable);
        this.mtd_getdata_inputUnit(newInputUnitTable.id, id.Id);
        this.nextInputUnitTableId += 1;
      }
    },
    removeInputUnitTable(tableId) {
      this.nextInputUnitTableId = 1;
      this.inputUnitTables = this.inputUnitTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.inputUnitTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    mtd_inputUnit: function (action) {
      // this.tableColSize = 7;
      this.modal.modal_form_inputUnit = true;

      if (action == "update") {
        this.modal.title = "Editar Insumo x Unidad";
        this.modal.action = action;
        this.inputUnit.unit_id = this.inputUnit.unit.id;
      } else {
        this.modal.title = "Agregar Insumo x Unidad";
        this.modal.action = "store";
        this.inputUnit.unit_id = "";
        this.inputUnit.state = 0;
      }
    },
    mtd_action_inputUnit: function () {
      let color = "success";
      let message = "";
      this.post({
        url:
          this.$store.getters.get__url + "/inputsunits/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.inputUnit,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_inputUnit(
              this.inputUnitTables[0].id,
              this.inputUnit.input_id
            );
          } else {
            let updateInputxUnit = response.data.data;
            let index = this.inputUnitTables[0].data.findIndex(
              (inputUnit) => inputUnit.id === updateInputxUnit.id
            );
            if (index !== -1) {
              this.$set(
                this.inputUnitTables[0].data,
                index,
                updateInputxUnit
              );
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_inputUnit(
              this.inputUnitTables[0].id,
              this.inputUnit.input_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_inputUnit: false,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_action_price: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/inputprices/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.price,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.input_id
            );
          } else {
            let updatedPrice = response.data.data;
            let index = this.priceTables[0].data.findIndex(
              (price) => price.id === updatedPrice.id
            );
            if (index !== -1) {
              this.$set(this.priceTables[0].data, index, updatedPrice);
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.input_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_price: false,
          };
          this.price = {
            id: "",
            input_id: "",
            sale_price: 0,
            purchase_price: 0,
            state: 0,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_getdata_inputUnit: function (tableId, inputId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byInputUnit/" +
          this.$store.getters.get_company.id +
          "/" +
          inputId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const tableIndex = this.inputUnitTables.findIndex(
            (table) => table.id === tableId
          );
          if (tableIndex !== -1) {
            this.$set(
              this.inputUnitTables[tableIndex],
              "data",
              response.data.data
            );
            let index = 1;
            this.inputUnitTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_show_inputUnit: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/inputsunits/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.inputUnit = response;
          this.mtd_inputUnit("update");
        })
        .catch((errors) => {});
    },
    show_Unit: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/inputsunits/byUnit/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.data_units.push({
              label: element.name,
              value: element.id,
              quantity: element.quantity,
            });
          });
        })
        .catch((errors) => {});
    },
    validatePositive(field) {
      if (this.price[field] <= 0) {
        this.price[field] = 1; // Establece el valor mínimo en 1
      }
    },
    /*** campus */
    mtd_get_campus: function (payload) {
      this.get({
        url:
          this.$store.getters.get__url + "/inputs/" + payload.Id + "/campus",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          console.log(response);
          this.modalCampu.modal_form = true;
          this.modalCampu.title = "Editar sedes";
          this.modalCampu.name = payload.name;
          this.editCampu = response.data;
        })
        .catch((errors) => {});
    },
    mtd_action_campus: function () {
      this.post({
        url: this.$store.getters.get__url + "/inputs/editcampus" ,
        token: this.$store.getters.get__token,
        params: {
          data: this.editCampu,
          pr:this.modalCampu.name,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.editCampu= [];
            this.modalCampu= {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            Swal.fire({
              title: "Editado correctamente!!",
              icon: 'success',
            });
          } else {
            Swal.fire({
              title: "Ocurrió un problema al editar!!",
              icon: 'error',
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>